import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service } from "../../../services/index";
//import {AddEditPurchaseOrder} from '../../addEditPurchaseOrder';
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
import { SalesOrderService } from "../../../services";
import { addPayment } from "././addPayment";

declare var google;

@Component({
  selector: "purchaseReturn",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./courierInward.html"
})
export class courierInward implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  temp_row = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  bsModalRef: BsModalRef;
  loadingIndicator: boolean = true;
  cour_det_id: "";
  reorderable: boolean = true;

  partyTypeList = ["CHEQUE PASS", "CHEQUE RETURN"];
  filter = {
    ref_no: "",
    cour_name: "",
    return_from_date: "",
    return_to_date: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "ref_no",
    orderDir: "asc"
  };
  pdcData = {
    chq_status: ""
  }
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  printData;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("verifyTemplate") verifyTemplate: TemplateRef<any>;
  @ViewChild("DepositTemplate") DepositTemplate: TemplateRef<any>;


  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("invoiceReturnTemplate") invoiceReturnTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  returnList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private returnservice: SalesOrderService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public modalService: BsModalService,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService
  ) { }

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center"
      },
      {
        name: "Ref No",
        prop: "ref_no",
        cellClass: "text-leftt",
        headerClass: "text-left",
        minWidth: 120,
        maxWidth: 120,
        width: 120
      },
      {
        name: "Particulars",
        prop: "particulars",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 130,
        maxWidth: 130,
        width: 130
      },
      {
        name: "Rec.Type",
        prop: "rec_type",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 130,
        maxWidth: 130,
        width: 130
      },
      {
        name: "Cour Date",
        prop: "date_fomated",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 140,
        maxWidth: 140,
        width: 140
      },
      {
        name: "Cour Name",
        prop: "cour_name",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160
      },
      {
        name: "Cour No",
        prop: "cour_no",
        cellClass: "text-right",
        headerClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 1200
      },
      {
        name: "Lr Date",
        prop: "lrdate_fomated",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 140,
        maxWidth: 140,
        width: 140
      },
      {
        name: "LR No",
        prop: "lr_no",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160
      },
     
      {
        name: "Action",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        sortable: false,
        cellTemplate: this.editDeleteTemplate
      },

    ];
    this.toggleCol = Object.assign({}, this.columns);
    this.getReturnList();
    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#ref_no").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.ref_no = "";
    this.filter.cour_name = "";

    // this.filter.po_no='';
    this.filter.return_from_date = "";
    this.filter.return_to_date = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getReturnList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }



  addEditReturn(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getReturnList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD COURIER INWARD",
          title: "ADD COURIER INWARD",
          tabParent: "SALES_ORDER",
          mode: mode,
          data: row,
          name: "addCourierInward"
        }
      };
      this.tabUpdateEvent.emit(tabObj);
    }
    if (mode == "View") {
      this.bsModalRef = this.modalService.show(addPayment, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-90",
      });
      row["mode"] = mode
      row["cour_id"] = row.cour_id
      this.bsModalRef.content.paymentdata = Object.assign({}, row);
      // this.bsModalRef.content.paymentUpdateEvent.subscribe(($e) => {
      //   // that.getCourierList
      //   const tabObj = {
      //     action: "CloseTab",
      //     params: {},
      //   };


      // });
    }
  }

  getReturnList(): void {
    if (this.filter.return_from_date == "") {
      this.filter.return_from_date == "";
    } else {
      this.filter.return_from_date = this.datePipe.transform(
        this.filter.return_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.return_to_date == "") {
      this.filter.return_to_date == "";
    } else {
      this.filter.return_to_date = this.datePipe.transform(
        this.filter.return_to_date,
        "yyyy-MM-dd"
      );
    }

    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      ref_no: this.filter.ref_no,
      cour_name: this.filter.cour_name,
      //po_no:this.filter.po_no,
      return_from_date: this.filter.return_from_date,
      return_to_date: this.filter.return_to_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.returnservice
      .getCourierList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.returnList = res.data;
      });
  }


}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/courier/courierInward.ts